// extracted by mini-css-extract-plugin
export var active = "_vj-1";
export var circle = "_vj-0";
export var completed = "_vj-2";
export var connector = "_vj-4";
export var connectorCompleted = "_vj-7";
export var connectorSpacer = "_vj-5";
export var iconStrokeOverride = "_vj-8";
export var labelContainer = "_vj-6";
export var pending = "_vj-3";